<template>
  <section>
    <form method="post" @submit.prevent="onSend">
      <form-wrapper :validator="$v.form">
        <form-group
          horizontal
          name="quantity"
          :label="$t('attributes.quantity')"
        >
          <b-input
            v-model.number="form.quantity"
            name="quantity"
            type="number"
            min="0"
            :placeholder="
              $t('message.please_input') + $t('attributes.quantity')
            "
            :open-on-focus="true"
          >
          </b-input>
        </form-group>

        <form-group
          horizontal
          name="sign_up_quantity"
          :label="$t('attributes.signup_quantity')"
        >
          <b-input
            v-model.number="form.sign_up_quantity"
            name="sign_up_quantity"
            type="number"
            min="0"
            :placeholder="
              $t('message.please_input') + $t('attributes.signup_quantity')
            "
          >
          </b-input>
        </form-group>

        <b-field horizontal>
          <b-button
            :loading="sending"
            type="is-primary"
            native-type="submit"
            :style="{ width: '100%' }"
          >
            {{ $t('attributes.update_data') }}
          </b-button>
        </b-field>
      </form-wrapper>
    </form>
  </section>
</template>

<script>
import { required, numeric, minValue } from 'vuelidate/lib/validators'
import { TRAVEL_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'

export default {
  name: 'TravelGroupCollaborateForm',

  props: {
    travelGroup: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      sending: false,

      code: this.travelGroup.code,
      form: this.extractFormValues(this.travelGroup)
    }
  },
  validations: {
    form: {
      quantity: { required, numeric, minValue: minValue(0) },
      sign_up_quantity: { required, numeric, minValue: minValue(0) }
    }
  },
  watch: {
    travelGroup(newGroup) {
      this.code = newGroup.code
      this.form = this.extractFormValues(newGroup)
    }
  },
  methods: {
    extractFormValues(data) {
      return {
        quantity: data.quantity,
        sign_up_quantity: data.sign_up_quantity
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      const api = `${TRAVEL_GROUPS_API}/${this.code}/quantity`

      this.sending = true
      try {
        const res = await this.axios.put(api, this.form)

        this.$emit('updated', res.data.data)
        notifyService.success(`${this.$t('attributes.update_succeed')}`)
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
